import React, { FunctionComponent } from 'react';
import Select from 'react-select';
import { Roles } from 'constants/literals';
import { compose } from 'recompose';
import { WithTranslation, withTranslation } from 'react-i18next';

interface InProps {
    onChange: (roles: string) => void;
    existingRoles: string;
}

type RolesSelectProps = InProps & WithTranslation;

interface OptionType {
    label: string;
    value: string;
}

const enhance = compose<RolesSelectProps, InProps>(
    withTranslation()
);

const RolesSelect: FunctionComponent<RolesSelectProps> = ({ onChange, existingRoles, t }) => {

    const selectableRoles = (): Roles[] => {
        return [Roles.noc, Roles.ixaas_client, Roles.ixaas_client_reader];
    };

    const defaultRoles = existingRoles
        ? existingRoles.split(',').map((role: string) => ({
              label: t(`rolesMap.${role}`),
              value: role,
          }))
        : [];

    const options = selectableRoles().map((role: string) => ({ label: t(`rolesMap.${role}`), value: role }));

    const optChanged = (option: OptionType[]) => {
        if (option != null) {
            const newRoles = option.map((role: OptionType) => role.value);
            onChange(newRoles.toString());
        } else onChange('');
    };

    return (
        <Select
            options={options}
            defaultValue={defaultRoles}
            isLoading={false}
            isDisabled={false}
            isMulti={true}
            checked={false}
            isSearchable={true}
            allowSelectAll={true}
            onChange={optChanged}
        />
    );
};

export default enhance(RolesSelect);
